(ns common.modules
  (:require
   [common.features.plan :as plan]))

(def options
  [{:key   :module/dealflow
    :label "Dealflow"}
   {:key   :module/portfolio
    :label "Portfolio"}
   {:key   :module/kpi-reporting
    :label "Company reporting"}
   {:key   :module/fundraising
    :label "Fundraising"}
   {:key   :module/kyc
    :label "KYC"}
   {:key   :module/tenant-kyc
    :label "Tenant KYC"}
   {:key   :module/counterparty-diligence
    :label "Counterparty diligence"}
   {:key   :module/counterparty-diligence-admin
    :label "Counterparty diligence admin"}
   {:key   :module/contract-kyc
    :label "Contract KYC"}
   {:key   :module/survey
    :label "Surveys"}
   {:key   :module/risk-module
    :label "Risk module"}
   {:key   :module/liabilities
    :label "Liabilities"}
   {:key   :module/sales-pipelines
    :label "Sales pipelines"}
   {:key   :module/exit-process-management
    :label "Exit process management"}
   {:key   :module/lp-reporting
    :label "Limited partners reporting"}
   {:key   :module/fee-tracking
    :label "Fee tracking"}
   {:key   :module/value-creation-activity
    :label "Value creation activity"}
   {:key   :module/screening
    :label "Screening"}
   {:key   :module/insider-groups-admin
    :label "Insider groups - admin privileges"}
   {:key   :module/insider-groups
    :label "Insider groups"}
   {:key   :module/surveys-admin
    :label "Surveys admin"}
   {:key   :module/dashboards
    :label "Metabase dashboards"}
   {:key   :module/dashboards-admin
    :label "Metabase dashboards admin"}
   {:key   :module/decisions
    :label "Decisions"}
   {:key   :module/entity-graph
    :label "Entity graph"}
   {:key   :module/contact-lists
    :label "Contact lists"}
   {:key   :module/zap-vault
    :label "Vaults"}
   {:key   :module/outlook-addin
    :label "Outlook add-in"}
   {:key   :module/mcp-connector-read
    :label "MCP connector — read only"}
   {:key   :module/mcp-connector-write
    :label "MCP connector — read & write"}
   {:key   :module/transaction-process
    :label "Transaction process"}])

(def modules
  (->> options
       (map :key)
       (into [])))

(def mcp-connector-modules
  "Modules that give access to the MCP connector. The tenant administrator
   activates them, and must accept the MCP terms first."
  #{:module/mcp-connector-read
    :module/mcp-connector-write})

(defn module-name
  [module]
  (->> options
       (filter (fn [m]
                 (= (:key m) module)))
       (first)
       :label))

(defn get-label
  [module]
  (module-name module))

(defn all-modules
  ([tenant tenant-plan]
   (all-modules tenant tenant-plan false))
  ([tenant tenant-plan mobile?]
   (->>
    modules
    (filter
     (fn [mod]
       (case mod
         :module/portfolio
         (or (plan/available :feature/dealflow nil :role/admin tenant-plan)
             (plan/available :feature/fund-management nil :role/admin tenant-plan))
         :module/dealflow
         (plan/available :feature/dealflow tenant :role/admin tenant-plan)
         :module/fundraising
         (and (plan/available :feature/fundraising tenant :role/admin tenant-plan)
              (not mobile?))
         :module/kpi-reporting
         (and (plan/available :feature/kpi-reporting tenant :role/admin tenant-plan)
              (not mobile?))
         :module/sales-pipelines
         (plan/available :feature/sales-pipelines tenant :role/admin tenant-plan)
         :module/exit-process-management
         (plan/available :feature/exit-process-management tenant :role/admin tenant-plan)
         :module/kyc
         (plan/available :feature/kyc tenant :role/admin tenant-plan)
         :module/tenant-kyc
         (plan/available :feature/tenant-kyc tenant :role/admin tenant-plan)
         :module/contract-kyc
         (plan/available :feature/contract-kyc tenant :role/admin tenant-plan)
         :module/survey
         (plan/available :feature/surveys tenant :role/admin tenant-plan)
         :module/risk-module
         (plan/available :feature/risk-module tenant :role/admin tenant-plan)
         :module/liabilities
         (plan/available :feature/liabilities tenant :role/admin tenant-plan)
         :module/fee-tracking
         (plan/available :feature/fee-tracking tenant :role/admin tenant-plan)
         :module/lp-reporting
         (plan/available :feature/lp-reporting tenant :role/admin tenant-plan)
         :module/value-creation-activity
         (plan/available :feature/value-creation-activity tenant :role/admin tenant-plan)
         :module/screening
         (plan/available :feature/screening tenant :role/admin tenant-plan)
         :module/insider-groups-admin
         (plan/available :feature/insider-groups tenant :role/admin tenant-plan)
         :module/insider-groups
         (plan/available :feature/insider-groups tenant :role/admin tenant-plan)
         :module/surveys-admin
         (plan/available :feature/surveys tenant :role/admin tenant-plan)
         :module/dashboards
         (plan/available :feature/metabase-dashboards tenant :role/admin tenant-plan)
         :module/dashboards-admin
         (plan/available :feature/metabase-dashboards tenant :role/admin tenant-plan)
         :module/reporting-db
         (plan/available :feature/reporting-db tenant :role/admin tenant-plan)
         :module/metabase-reporting-db
         (and (plan/available :feature/reporting-db tenant :role/admin tenant-plan)
              (plan/available :feature/metabase-reporting-db tenant :role/admin tenant-plan))
         :module/decisions
         (plan/available :feature/decisions tenant :role/admin tenant-plan)
         :module/entity-graph
         (plan/available :feature/entity-graph tenant :role/admin tenant-plan)
         :module/zap-vault
         (plan/available :feature/zap-vault tenant :role/admin tenant-plan)
         :module/contact-lists
         (plan/available :feature/contact-lists tenant :role/admin tenant-plan)
         :module/counterparty-diligence
         (plan/available :feature/counterparty-diligence tenant :role/admin tenant-plan)
         :module/counterparty-diligence-admin
         (plan/available :feature/counterparty-diligence tenant :role/admin tenant-plan)
         :module/outlook-addin
         (plan/available :feature/outlook-addin tenant :role/admin tenant-plan)
         (:module/mcp-connector-read :module/mcp-connector-write)
         (plan/available :feature/mcp-connector tenant :role/admin tenant-plan)
         :module/transaction-process
         (plan/available :feature/transaction-process tenant :role/admin tenant-plan)
         true))))))

(defn plan-modules
  [plan-type]
  (let [plan (get plan/default-plans plan-type)]
    (->>
     modules
     (filter
      (fn [mod]
        (case mod
          :module/portfolio
          (or (plan/available :feature/dealflow nil :role/admin plan)
              (plan/available :feature/fund-management nil :role/admin plan))
          :module/dealflow
          (plan/available :feature/dealflow nil :role/admin plan)
          :module/fundraising
          (plan/available :feature/fundraising nil :role/admin plan)
          :module/kpi-reporting
          (plan/available :feature/kpi-reporting nil :role/admin plan)
          :module/sales-pipelines
          (plan/available :feature/sales-pipelines nil :role/admin plan)
          :module/exit-process-management
          (plan/available :feature/exit-process-management nil :role/admin plan)
          :module/kyc
          (plan/available :feature/kyc nil :role/admin plan)
          :module/tenant-kyc
          (plan/available :feature/tenant-kyc nil :role/admin plan)
          :module/contract-kyc
          (plan/available :feature/contract-kyc nil :role/admin plan)
          :module/survey
          (plan/available :feature/surveys nil :role/admin plan)
          :module/risk-module
          (plan/available :feature/risk-module nil :role/admin plan)
          :module/fee-tracking
          (plan/available :feature/fee-tracking nil :role/admin plan)
          :module/lp-reporting
          (plan/available :feature/lp-reporting nil :role/admin plan)
          :module/screening
          (plan/available :feature/screening nil :role/admin plan)
          :module/insider-groups-admin
          (plan/available :feature/insider-groups nil :role/admin plan)
          :module/insider-groups
          (plan/available :feature/insider-groups nil :role/admin plan)
          :module/surveys-admin
          (plan/available :feature/surveys nil :role/admin plan)
          :module/dashboards
          (plan/available :feature/metabase-dashboards nil :role/admin plan)
          :module/dashboards-admin
          (plan/available :feature/metabase-dashboards nil :role/admin plan)
          :module/reporting-db
          (plan/available :feature/reporting-db nil :role/admin plan)
          :module/metabase-reporting-db
          (and (plan/available :feature/reporting-db nil :role/admin plan)
               (plan/available :feature/metabase-reporting-db nil :role/admin plan))
          :module/decisions
          (plan/available :feature/decisions nil :role/admin plan)
          :module/entity-graph
          (plan/available :feature/entity-graph nil :role/admin plan)
          :module/zap-vault
          (plan/available :feature/zap-vault nil :role/admin plan)
          :module/contact-lists
          (plan/available :feature/contact-lists nil :role/admin plan)
          :module/counterparty-diligence
          (plan/available :feature/counterparty-diligence nil :role/admin plan)
          :module/counterparty-diligence-admin
          (plan/available :feature/counterparty-diligence nil :role/admin plan)
          :module/outlook-addin
          (plan/available :feature/outlook-addin nil :role/admin plan)
          (:module/mcp-connector-read :module/mcp-connector-write)
          (plan/available :feature/mcp-connector nil :role/admin plan)
          :module/transaction-process
          (plan/available :feature/transaction-process nil :role/admin plan)
          true))))))

(defonce module->route
  {:module/dealflow                :oppos-grid
   :module/fundraising             :fundraising-opportunities-grid
   :module/kpi-reporting           :kpi-categories
   :module/portfolio               :holdings-grid
   :module/sales-pipelines         :sales-opportunities-grid
   :module/exit-process-management :exit-opportunities-grid
   nil                             :companies-grid})

(defn available-modules
  ([tenant tenant-modules tenant-plan role-modules]
   (available-modules tenant tenant-plan tenant-modules role-modules false))
  ([tenant tenant-modules tenant-plan role-modules mobile?]
   (let [tenant-modules (set tenant-modules)
         role-modules (set role-modules)]
     (->> (all-modules tenant tenant-plan mobile?)
          (filter tenant-modules)
          (filter role-modules)))))

(defn team-member?
  [user team]
  (contains? (:team/members team) (:db/id user)))

(defn resolve-account-modules
  [{:keys [tenant tenant-modules tenant-plan all-teams user-account mobile? owner?]}]
  (let [tenant-modules (->> (all-modules tenant tenant-plan mobile?)
                            (filter (set tenant-modules)))
        user-in-team? (partial team-member? user-account)]
    (if owner?
      (set tenant-modules)
      (->> all-teams
           (filter user-in-team?)
           (mapcat (fn [team]
                     (->> tenant-modules
                          (filter (set (:team/modules team))))))
           (set)))))

(defn has-module-access?
  [tenant tenant-modules tenant-plan role-modules mobile? module]
  (let [available-modules
        (available-modules tenant tenant-modules tenant-plan role-modules mobile?)]
    (contains? (set available-modules) module)))

(defn has-module?
  "Returns truthy if account has module `m` in :account-modules.
   Works for sets, vectors, lists, or nil."
  [account-current-permissions m]
  (let [mods (:account-modules account-current-permissions)]
    (if (set? mods)
      (contains? mods m)
      (some #{m} mods))))
